<template>
  <div>
    <div>
      <p class="mb-4 mt-4 text-left text-dark-gray sm:mt-2">
        By clicking
        <strong>Sign & Continue</strong>
        you certify that you are authorized to sign the contract{{
          contracts?.length > 1 ? 's' : ''
        }}
        set forth below on behalf of {{ carrierLegalName }}, you have reviewed
        and accept the terms of each contract, and you intend to electronically
        sign each contract listed below. If you have any questions, please
        contact
        <a
          :href="'mailto:' + supportEmail"
          class="bold"
        >
          {{ `${supportEmail}.` }}
        </a>
      </p>
      <CollapsiblePanel
        title="Contracts"
        title-size="text-sm"
        background-color="bg-white"
        :hide-header="uploadedContracts?.length === 0"
      >
        <div class="flex flex-col gap-4">
          <div
            v-for="c in contracts"
            :key="c?.id"
            class="group w-full rounded-md border border-transparent"
          >
            <a
              :href="c?.contract?.url"
              target="_blank"
              class="flex items-center justify-between gap-2 rounded-md border border-light-gray p-3 text-dark-gray group-hover:border-yellow-500 group-hover:bg-yellow-10 group-hover:text-yellow-500"
            >
              <!-- <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-8 h-8">
              <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m5.231 13.481L15 17.25m-4.5-15H5.625c-.621 0-1.125.504-1.125 1.125v16.5c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9zm3.75 11.625a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z" />
            </svg> -->
              <div class="flex gap-2 text-dark-gray">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M19.5 14.25V11.625C19.5 10.7299 19.1444 9.87145 18.5115 9.23851C17.8786 8.60558 17.0201 8.25 16.125 8.25H14.625C14.3266 8.25 14.0405 8.13147 13.8295 7.9205C13.6185 7.70952 13.5 7.42337 13.5 7.125V5.625C13.5 4.72989 13.1444 3.87145 12.5115 3.23851C11.8785 2.60558 11.0201 2.25 10.125 2.25H8.25M10.5 2.25H5.625C5.004 2.25 4.5 2.754 4.5 3.375V20.625C4.5 21.246 5.004 21.75 5.625 21.75H18.375C18.996 21.75 19.5 21.246 19.5 20.625V11.25C19.5 8.86305 18.5518 6.57387 16.864 4.88604C15.1761 3.19821 12.8869 2.25 10.5 2.25Z"
                    stroke="#6C7C9D"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <div class="flex flex-col items-start justify-center gap-0">
                  <span class="leading-tight text-dark-gray">
                    {{ c?.name }}
                  </span>
                  <span
                    class="hidden text-left text-xxs text-gray-over-dark sm:inline"
                  >
                    {{ c?.contract?.filename }}
                  </span>
                </div>
              </div>
              <div
                class="flex items-center text-gray-over-dark group-hover:text-yellow-500"
              >
                <p
                  class="font-medium text-steel-700"
                  style="font-family: 11px"
                >
                  View
                </p>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <path
                    d="M10 8L6 4L6 12L10 8Z"
                    fill="#6C7C9D"
                  />
                </svg>
              </div>
            </a>
          </div>
          <div
            v-if="tax_form_contract_preview && !is_bypassing_tax_form"
            class="group w-full rounded-md border border-transparent"
          >
            <a
              :href="tax_form_contract_preview?.url"
              target="_blank"
              class="flex items-center justify-between gap-2 rounded-md border border-light-gray p-3 text-dark-gray group-hover:border-yellow-500 group-hover:bg-yellow-10 group-hover:text-yellow-500"
            >
              <!-- <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-8 h-8">
              <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m5.231 13.481L15 17.25m-4.5-15H5.625c-.621 0-1.125.504-1.125 1.125v16.5c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9zm3.75 11.625a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z" />
            </svg> -->
              <div class="flex gap-2 text-dark-gray">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M19.5 14.25V11.625C19.5 10.7299 19.1444 9.87145 18.5115 9.23851C17.8786 8.60558 17.0201 8.25 16.125 8.25H14.625C14.3266 8.25 14.0405 8.13147 13.8295 7.9205C13.6185 7.70952 13.5 7.42337 13.5 7.125V5.625C13.5 4.72989 13.1444 3.87145 12.5115 3.23851C11.8785 2.60558 11.0201 2.25 10.125 2.25H8.25M10.5 2.25H5.625C5.004 2.25 4.5 2.754 4.5 3.375V20.625C4.5 21.246 5.004 21.75 5.625 21.75H18.375C18.996 21.75 19.5 21.246 19.5 20.625V11.25C19.5 8.86305 18.5518 6.57387 16.864 4.88604C15.1761 3.19821 12.8869 2.25 10.5 2.25Z"
                    stroke="#6C7C9D"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <div class="flex flex-col items-start justify-center gap-0">
                  <span class="leading-tight text-dark-gray">
                    {{ tax_form?.name }}
                  </span>
                  <span
                    class="hidden text-left text-xxs text-gray-over-dark sm:inline"
                  >
                    {{ tax_form_contract_preview?.filename }}
                  </span>
                </div>
              </div>
              <div
                class="flex items-center text-gray-over-dark group-hover:text-yellow-500"
              >
                <p
                  class="font-medium text-steel-700"
                  style="font-family: 11px"
                >
                  View
                </p>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <path
                    d="M10 8L6 4L6 12L10 8Z"
                    fill="#6C7C9D"
                  />
                </svg>
              </div>
            </a>
          </div>
        </div>
      </CollapsiblePanel>
      <CollapsiblePanel
        v-if="uploadedContracts?.length > 0"
        title="Executed Contracts <span class='text-steel-800'>(For Reference Only)</span>"
        title-size="text-sm"
        background-color="bg-white"
      >
        <div
          v-for="c in uploadedContracts"
          :key="c?.id"
          class="group w-full rounded-md border border-transparent"
        >
          <a
            :href="c?.contract?.url"
            target="_blank"
            class="flex items-center justify-between gap-2 rounded-md border border-light-gray p-3 text-dark-gray group-hover:border-yellow-500 group-hover:bg-yellow-10 group-hover:text-yellow-500"
          >
            <div class="flex gap-2 text-dark-gray">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M19.5 14.25V11.625C19.5 10.7299 19.1444 9.87145 18.5115 9.23851C17.8786 8.60558 17.0201 8.25 16.125 8.25H14.625C14.3266 8.25 14.0405 8.13147 13.8295 7.9205C13.6185 7.70952 13.5 7.42337 13.5 7.125V5.625C13.5 4.72989 13.1444 3.87145 12.5115 3.23851C11.8785 2.60558 11.0201 2.25 10.125 2.25H8.25M10.5 2.25H5.625C5.004 2.25 4.5 2.754 4.5 3.375V20.625C4.5 21.246 5.004 21.75 5.625 21.75H18.375C18.996 21.75 19.5 21.246 19.5 20.625V11.25C19.5 8.86305 18.5518 6.57387 16.864 4.88604C15.1761 3.19821 12.8869 2.25 10.5 2.25Z"
                  stroke="#6C7C9D"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <div class="flex flex-col items-start justify-center gap-0">
                <span class="leading-tight text-dark-gray">
                  {{ c?.contract?.name }}
                </span>
                <span
                  class="hidden text-left text-xxs text-gray-over-dark sm:inline"
                >
                  {{ c?.contract?.filename }}
                </span>
              </div>
            </div>
            <div
              class="flex items-center text-gray-over-dark group-hover:text-yellow-500"
            >
              <p
                class="font-medium text-steel-700"
                style="font-family: 11px"
              >
                View
              </p>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
              >
                <path
                  d="M10 8L6 4L6 12L10 8Z"
                  fill="#6C7C9D"
                />
              </svg>
            </div>
          </a>
        </div>
      </CollapsiblePanel>
    </div>
    <form-navigation-buttons
      v-if="!isNavigationDisabled"
      :enabled="!isNavigationDisabled"
      :component-identifier="componentIdentifier"
      :buttons-to-display="buttonsToDisplay"
      :is-button-disabled="isButtonDisabled"
      :final-button-loading="isButtonLoading"
      @next="handleNext"
      @back="handleBack"
      @edit="handleEdit"
      @exit-modal="emitExitModal"
    />
  </div>
</template>

<script>
import FormNavigationButtons from '@/components/FormNavigationButtons.vue';
import CollapsiblePanel from '@/components/CollapsiblePanel.vue';
import { useFormRouter } from '@/composables/formRouter';
import { useStore, mapState } from 'vuex';
import { computed, ref } from 'vue';

export default {
  name: 'ContractStepTwo',
  components: {
    FormNavigationButtons,
    CollapsiblePanel,
  },
  props: {
    data: Object,
    formPosition: Number,
    title: String,
    updateField: Function,
    nextStep: Function,
    stepName: String,
    skipStep: Function,
    screenSize: String,
  },
  data() {
    return {
      taxFormLoaded: false,
    };
  },
  computed: {
    ...mapState({
      carrierLegalName: (state) =>
        state.carriers?.carrierDetails?.legal_name || '',
      brokerLegalName: (state) => state.brokers?.logo?.legal_name || '',
      contracts: (state) => state.carriers?.contracts || [],
      onboarding_packet_id: (state) => state.onboardingPacket?.id || null,
      supportEmail: (state) =>
        state.carriers?.carrierData?.connection?.issuer?.support_email,
      legalName: (state) =>
        state.carriers?.carrierData?.connection?.issuer?.legal_name,
    }),
    uploadedContracts() {
      const flag =
        this.$store.state.users.featureFlags?.display_executed_contracts
          ?.enabled;

      return flag
        ? this.$store.state.carriers?.brokerUploadedContracts || []
        : [];
    },
    latest_tax_form_submission() {
      if (this.$store.state.taxQuestions?.latest_tax_form_submission) {
        return this.$store.state.taxQuestions?.latest_tax_form_submission;
        // } else if (this.$store.state.carriers?.carrierData?.latest_tax_form_submission) {
        //   return this.$store.state.carriers?.carrierData?.latest_tax_form_submission;
      } else {
        return {};
      }
    },
    tax_form_contract_preview() {
      return this.latest_tax_form_submission?.tax_form_contract_preview || {};
    },
    is_bypassing_tax_form() {
      if (
        this.$store.state.carriers?.carrierData?.connection?.issuer
          ?.is_w9_optional == true &&
        this.$store.state.taxQuestions?.has_submitted_bypass_w9 == true
      ) {
        return true;
      } else if (
        this.$store.state.carriers?.carrierData?.connection?.issuer
          ?.is_w8_optional == true &&
        this.$store.state.taxQuestions?.has_submitted_bypass_w8 == true
      ) {
        return true;
      } else {
        return false;
      }
    },
    tax_form() {
      return this.latest_tax_form_submission?.tax_form || {};
    },
  },
  // async mounted() {
  //   if (!this.$store.state.carriers?.carrierData?.latest_tax_form_submission?.tax_form_contract_preview) {
  //     await this.$store.dispatch('taxQuestions/getLatestTaxFormSubmission', this.onboarding_packet_id);
  //   }
  // },
  watch: {
    stepName: async function (val) {
      if (val === 'Contract-2') {
        await Promise.all([
          this.$store.dispatch(
            'carriers/setContractInformation',
            this.$store.state.onboardingPacket?.id
          ),
          this.$store.dispatch(
            'carriers/getBrokerUploadedContracts',
            this.$store.state.onboardingPacket?.id
          ),
        ]);
        // Enable Agree & Continue button if stepName is Contract-2
        this.$store.commit('toggleDisabledButton', {
          bool: false,
          source: 'ContractStepTwo #1',
        });
      }
    },
    // tax_form_contract_preview: function (val) {
    //   if (!(val && val !== {})) {
    //     this.$store.dispatch('taxQuestions/getLatestTaxFormSubmission', this.onboarding_packet_id);
    //   }
    // },
  },
  setup(_, { emit }) {
    const store = useStore();
    const componentIdentifier = 'Contract-2';
    const formRouter = useFormRouter(componentIdentifier);
    const isNavigationDisabled = computed(() => formRouter.isDisabled.value);
    const firstTime = computed(
      () =>
        store.state.firstTime?.[
          formRouter.componentStep.value?.firstTimeIdentifier
        ]
    );
    const buttonsToDisplay = 'finish-sign';
    const isButtonDisabled = false;
    const isButtonLoading = ref(false);

    const handleNext = () => {
      store.commit(
        'addFormDebugMessage',
        componentIdentifier + ": 'handleNext' called"
      );
      if (isNavigationDisabled.value)
        return store.commit(
          'addFormDebugMessage',
          'ERROR: ' +
            componentIdentifier +
            ': formRouter is disabled, returning'
        );
      isButtonLoading.value = true;
      formRouter.moveToStepByIdentifier('AttemptToComplete');
    };

    const handleBack = () => {
      store.commit(
        'addFormDebugMessage',
        componentIdentifier + ": 'handleBack' called"
      );
      if (isNavigationDisabled.value)
        return console.log(
          'ERROR: ' +
            componentIdentifier +
            ': formRouter is disabled, returning'
        );
      formRouter.moveToPreviousStep();
    };

    const handleEdit = () => {
      store.commit(
        'addFormDebugMessage',
        componentIdentifier + ": 'handleEdit' called"
      );
      if (isNavigationDisabled.value)
        return console.log(
          'ERROR: ' +
            componentIdentifier +
            ': formRouter is disabled, returning'
        );
      formRouter.editActiveStep();
      store.commit(
        'addFormDebugMessage',
        componentIdentifier + ': Manually redirecting to Contract-1'
      );
      formRouter.moveToStepByIdentifier('Contract-1');
    };

    const emitExitModal = () => {
      store.commit(
        'addFormDebugMessage',
        componentIdentifier + ": 'emitExitModal' called"
      );
      emit('exit-modal');
    };

    return {
      componentIdentifier,
      handleNext,
      handleBack,
      handleEdit,
      buttonsToDisplay,
      isButtonDisabled,
      isNavigationDisabled,
      firstTime,
      isButtonLoading,
      emitExitModal,
    };
  },
};
</script>

<style scoped>
p {
  @apply text-left;
}
</style>
